import React, {useEffect, useState} from "react"
import HorizontalBanner, {HorizontalBannerPositions} from "@irati-web/platform/src/components/HorizontalBanner"
import {Body} from "@irati/ui/src/Typography"
import {FormattedMessage} from "@irati/utils/lang"
import {ButtonLink} from "@irati/ui/src/Link"
import topupService from "@irati/wallet/services/TopUp"
import Flex from "@irati/ui/src/Flex"
import theme from "@irati/ui/src/global/theme"

const RewardMigrationTopBanner: React.FC = () => {
  const [waivedTiers, setWaivedTiers] = useState<boolean>(false)
  useEffect(() => {
    topupService.serviceFeesWaived().then((serviceFeeWaived) => setWaivedTiers(serviceFeeWaived))
  }, [])
  if (!waivedTiers) {
    return null
  }
  return (
    <HorizontalBanner position={HorizontalBannerPositions.ABSOLUTE}>
      <Flex justifyContent="center" alignItems="center" margin="auto" gap="1rem" wrap="wrap">
        <Body small color={theme.colors.greys.white} marginBottom={0}>
          <Body display="inline" textAlign="center" weight="bold" color={theme.colors.tertiary.o_400}>
            <FormattedMessage id="wallet.reward.admin.creditTopup.notice" />
          </Body>
          <Body display="inline" weight="bold" marginLeft={1} color={theme.colors.greys.white}>
            <FormattedMessage id="wallet.reward.admin.creditTopup.messageExpiring" />
          </Body>
        </Body>
        <ButtonLink href="https://www.perkbox.com/resources/product/rewarding-with-global-reward" target="_blank" inverted small>
          <FormattedMessage id="platform.ui.banner.cta.text" />
        </ButtonLink>
      </Flex>
    </HorizontalBanner>
  )
}

export default RewardMigrationTopBanner
